import usePlaywireRamp from '@src/hooks/usePlaywireRamp';

const PlaywireRamp = () => {
    const { isLoaded } = usePlaywireRamp();

    return null;
};

export default PlaywireRamp;
